import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { Clients, ClientsResponse } from '@interfaces';
import { HttpService, AuthService } from '@core';
import { LoaderService } from '@management';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BenefitManagementService {
  public clientsResponseCache$: Observable<Clients[]>;

  constructor(
    private readonly httpService: HttpService,
    private readonly authService: AuthService,
    private readonly loader: LoaderService,
  ) { }

  /**
   * Get list of clients for Benefit and Management module, which the user has access
   * @returns
   */
  public getClientsListByAccess(): Observable<Clients[]> {
    if (!this.clientsResponseCache$) {
      this.loader.showLoader();
      this.clientsResponseCache$ = this.httpService
        .get<ClientsResponse>(
          `${AppConstants.URLS.BAP_CLIENTS}${this.authService.userEmail}&subscription-key=${environment.scApiSubscriptionKey}`
        )
        .pipe(
          // tap((res) => res.listOfClients.forEach((e) => {
          //   res.listOfClients[0].olA_Access_Type = UserAccessLevel.LEVEL_A
          //   res.listOfClients[1].olA_Access_Type = UserAccessLevel.LEVEL_B
        // })),
          tap(() => {
            this.loader.hideLoader();  
          }),
          map((res) => res.listOfClients.filter((x) => x.olA_Access === 'Y')),
          shareReplay(1)
        );
    }
    return this.clientsResponseCache$;
  }

  isInternalUser(): Observable<boolean> {
    return this.getClientsListByAccess().pipe(
      map((res) => res[0].userType === 'Internal')
    );
  }
}
